import { NgModule } from '@angular/core';

import { InstanceCustomFieldsComponent } from './instance-fields/instance-custom-fields.component';
import { InstanceCustomGroupComponent } from './instance-group/instance-custom-group.component';
import { InstanceCustomFieldComponent } from './instance-field/instance-custom-field.component';
import { InstanceCustomAttachmentComponent } from './instance-attachment/instance-custom-attachment.component';
import { InstanceCustomFieldsService } from './instance-custom-fields.service';

import { CustomFieldValueModule } from 'features/custom-fields/custom-field-value/custom-field-value.module';
import { FileUploadModule, CardModule, PageHeaderModule } from '@certemy/ui-components';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { DateFormatPipe } from '@certemy/common';

@NgModule({
  imports: [CertemyCommonModule, FileUploadModule, CustomFieldValueModule, CardModule, PageHeaderModule],
  exports: [
    InstanceCustomFieldsComponent,
    InstanceCustomGroupComponent,
    InstanceCustomFieldComponent,
    InstanceCustomAttachmentComponent,
  ],
  declarations: [
    InstanceCustomFieldsComponent,
    InstanceCustomGroupComponent,
    InstanceCustomFieldComponent,
    InstanceCustomAttachmentComponent,
  ],
  providers: [InstanceCustomFieldsService, DateFormatPipe],
})
export class InstanceCustomFieldsModule {}
